import React from 'react';
import {FoodDishesPage} from './WholeCode';
import WholeCode from './WholeCode';
const Vegetable = () => {
    return (
        <>
        <WholeCode
        mainHeading="Vegetable Recipe Online Industry"
        belowParagraph="What are you waiting for"
        btn="Get Started"
        cardHeading="Vegetable Recipe"
        cardBelowHeading="Order Your Favourite"
        cardParagraph="Did you know, Collin Street Bakery has been baking the world’s best fruitcake since 1896? That’s right! Our world-famous DeLuxe® Fruitcake recipe has won our bakery global prestige and fame. We begin with our Business, Costa Rican pineapple, ripe cherries, and golden raisins."
        topHomepageclass="homePagepic"
    />
     <FoodDishesPage
    foodDishesImgSrc1="https://images.pexels.com/photos/3987348/pexels-photo-3987348.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc2="https://images.pexels.com/photos/3872406/pexels-photo-3872406.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" 
    foodDishesImgSrc3="https://images.pexels.com/photos/1351238/pexels-photo-1351238.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc4="https://images.pexels.com/photos/1656666/pexels-photo-1656666.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc5="https://images.pexels.com/photos/3873912/pexels-photo-3873912.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc6="https://images.pexels.com/photos/1300972/pexels-photo-1300972.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
     />
    </>
    )
}
export default Vegetable;